import React, { useRef, useState, useEffect } from 'react'

import Slider from 'react-slick'

//Dispatch
import { useGetFeaturedPropertiesQuery } from '@apis/middlewareTokkoApi/properties'
import { Property, RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryProperties from '@hooks/useQueryProperties'
import { ElementHTML } from '@helpers/helper.rendering'

const MOCKDATA = {
  title: 'Titulo de la sección',
  propCard: '1',
}

const SummaryProps_1 = (props: RealEstateDataPageComponentData) => {
  const { isDemo, global_data, titleElement, titleHexa } = props
  const { title } = isDemo ? MOCKDATA : props
  const propCard = isDemo ? MOCKDATA.propCard : global_data.content?.cardsProperties?.type_id ?? '1'

  const sliderRef = useRef<any>()

  const tokkoKey = global_data.pageConfig.keys.tokko

  const middlewarev2: boolean = process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() === 'true'

  const { data: featuredPropertiesData, isLoading: isLoadingProperties } = tokkoKey
    ? middlewarev2
      ? useQueryProperties({
          filters: {
            location: [],
            type: [],
            operation: '',
            environments: '',
            bedrooms: '',
            is_starred_on_web: true,
            age: '',
            address: '',
            producer_id: '',
            price: {},
            environments_types: [],
            generals: [],
            services: [],
            specials: [],
          },
          tokkoKey,
        })
      : useGetFeaturedPropertiesQuery({ API_KEY: tokkoKey })
    : useQueryProperties({
        filters: {
          location: [],
          type: [],
          operation: '',
          environments: '',
          is_starred_on_web: true,
          bedrooms: '',
          age: '',
          address: '',
          producer_id: '',
          price: {},
          environments_types: [],
          generals: [],
          services: [],
          specials: [],
        },
        tokkoKey,
      })

  const Card = require(`@components/cardsProperties/${propCard}`)?.default

  const [settings, setOption] = useState<any>()

  useEffect(() => {
    return setOption({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: `${screen?.width > 992 ? screen?.width / 3.75 : 50}px`,
      slidesToScroll: 1,
    })
  }, [])

  console.log(featuredPropertiesData)

  return (
    <section
      className={
        'a p-y-config' +
        (!isLoadingProperties &&
        // (featuredPropertiesData?.objects?.length === 0 ||
        //   featuredPropertiesData?.objects.filter(
        //     (prop: Property) => prop.is_starred_on_web === true,
        //   ).length === 0 ||
        //   featuredPropertiesData === undefined)
        //   ? ' d-none'
        //   : '')
        (featuredPropertiesData?.objects?.length === 0 || featuredPropertiesData === undefined)
          ? ' d-none'
          : '')
      }
      id="featured-props"
    >
      <Container fluid>
        <Row>
          <Col xs={12}>
            <ElementHTML
              children={title}
              className="section-title text-center text-lg-start pb-lg-5"
              elementType={titleElement || 'h2'}
              style={{ color: titleHexa }}
            />
          </Col>
        </Row>
      </Container>

      <div className="props d-flex align-items-center justify-content-center my-4">
        <Slider
          ref={sliderRef}
          {...settings}
          lazyLoad="ondemand"
          className="overflow-hidden"
        >
          {isLoadingProperties
            ? [1, 2, 3].map((index) => (
                <Card
                  key={index}
                  skeleton={true}
                  global_data={global_data}
                />
              ))
            : (tokkoKey
                ? featuredPropertiesData?.objects
                : featuredPropertiesData?.objects.filter(
                    (prop: Property) => prop.is_starred_on_web === true,
                  )
              )?.map((prop: Property, index: number) => (
                <Card
                  key={index}
                  basic={true}
                  property={prop}
                  global_data={global_data}
                />
              ))}
        </Slider>
        <div className="arrows-owl">
          <div
            className="d-lg-none arrow"
            onClick={() => sliderRef.current.slickPrev()}
          >
            {' '}
            <i className="isArrowFeatured"></i> <i className="isArrowFeatured"></i>
          </div>
          <div
            className="d-lg-none arrow reverse"
            onClick={() => sliderRef.current.slickNext()}
          >
            {' '}
            <i className="isArrowFeatured"></i> <i className="isArrowFeatured"></i>{' '}
          </div>

          <i
            className="d-none d-lg-block icon-arrow-left isArrowFeatured"
            onClick={() => sliderRef.current.slickPrev()}
          ></i>
          <i
            className="d-none d-lg-block icon-arrow isArrowFeatured"
            onClick={() => sliderRef.current.slickNext()}
          ></i>
        </div>
      </div>
    </section>
  )
}

export default SummaryProps_1
